webpackJsonp([6],{

/***/ "+sWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FloatMenu_vue__ = __webpack_require__("GtYY");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c705dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FloatMenu_vue__ = __webpack_require__("dACX");
function injectStyle (ssrContext) {
  __webpack_require__("0H2V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FloatMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c705dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FloatMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0H2V":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oLEQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("03ce48f5", content, true, {});

/***/ }),

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "CbiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* harmony default export */ __webpack_exports__["a"] = ((function (window) {
    var _supporter;

    var navigator = window.navigator,
        userAgent = navigator.userAgent,
        android = userAgent.match(/(Android)[\s\/]*([\d\.]+)/i),
        ios = userAgent.match(/(iPad|iPhone|iPod)[\w\s]*;(?:[\w\s]+;)*[\w\s]+(?:iPad|iPhone|iPod)?\sOS\s([\d_\.]+)/i),
        wp = userAgent.match(/(Windows\s+Phone)(?:\sOS)?\s([\d\.]+)/i),
        adrPadRegex = /pad|XiaoMi\/MiPad|lepad|YOGA|MediaPad|GT-P|SM-T|GT-N5100|sch-i800|HUAWEI\s?[MTS]\d+-\w+|Nexus\s7|Nexus\s8|Nexus\s11|Kindle Fire HD|Tablet|tab/i,
        isWebkit = /WebKit\/[\d.]+/i.test(userAgent),
        isSafari = ios ? navigator.standalone ? isWebkit : /Safari/i.test(userAgent) && !/CriOS/i.test(userAgent) && !/MQQBrowser/i.test(userAgent) && !/baidubrowser/i.test(userAgent) : false,
        os = {};

    if (android) {
        os.android = true;
        os.version = android[2];
        os.android4 = /^4/.test(os.version);
        os.android3 = /^3/.test(os.version);
        os.android2 = /^2/.test(os.version);
        os.androidpad = adrPadRegex.test(userAgent);
    }
    if (ios) {
        os.ios = true;
        os.version = ios[2].replace(/_/g, '.');
        os['ios' + os.version.match(/^(\w+)/i)[1]] = true;
        if (ios[1] === 'iPad') {
            os.ipad = true;
        } else if (ios[1] === 'iPhone') {
            os.iphone = true;
        } else if (ios[1] === 'iPod') {
            os.ipod = true;
        }
    }
    if (wp) {
        os.wp = true;
        os.version = wp[2];
        os.wp8 = /^8/.test(os.version);
        os.wp7 = /^7/.test(os.version);
        os.wppad = /Pad/i.test(os.version);
    }

    var supporter = (_supporter = {
        /**
         * 移动设备操作系统信息，可能会包含以下属性:
         *
         *  Boolean : android
         *  Boolean : android4
         *  Boolean : android3
         *  Boolean : android2
         *  Boolean : ios
         *  Boolean : ios7
         *  Boolean : ios6
         *  Boolean : ios5
         *  Boolean : ipad
         *  Boolean : iphone
         *  Boolean : ipod
         *  Boolean : wp
         *  Boolean : wp8
         *  Boolean : wp7
         *  Boolean : wppad
         *  String : version 系统版本号
         *
         */
        os: os,

        /**
         * 是否智能设备
         */
        isSmartDevice: function () {
            return !!(os.ios || os.android || os.wp);
        }(),

        /**
         * 是否webkit内核浏览器
         */
        isWebkit: isWebkit,

        /**
         * 是否safari浏览器
         */
        isSafari: isSafari,

        /**
         * 低于iOS7
         */
        isBelowIos7: !!(os.ios && os.version.match(/^(\w+)/i)[1] < 7),

        /**
         * 是否UC浏览器
         */
        isUC: /UC/i.test(userAgent),

        /**
         * 是否QQ浏览器
         */
        isQQ: /QBrowser/i.test(userAgent),

        /**
         * 是否是微信内置浏览器
         */
        isWeixin: /MicroMessenger/i.test(userAgent),

        // 判断是否是搜狗浏览器
        isSogouBrowser: /sogou/i.test(userAgent),

        // 判断是否是手机百度
        isBaiduboxapp: /baiduboxapp/i.test(userAgent),

        /* 是否是百度浏览器 */
        isBaiduBrowser: /baidubrowser/i.test(userAgent),

        /* 华为手机 */
        // isHuawei: /huawei/i.test(userAgent),
        isHuawei: /huawei|honor/ig.test(userAgent),

        /* 小米手机 */
        // isXiaomi: /MI\s\d/i.test(userAgent),
        isXiaomi: /HM|RedMi|Mi/ig.test(userAgent),

        /* oppo手机 */
        isOppo: /oppo/i.test(userAgent),

        /* vivo手机 */
        isVivo: /vivo/i.test(userAgent),

        /* 三星手机 */
        isSamsung: /SAMSUNG/i.test(userAgent)

    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_supporter, 'isBaiduBrowser', /baidubrowser/i.test(userAgent)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_supporter, 'isBaiduBoxApp', /baiduboxapp/i.test(userAgent)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_supporter, 'isSogou', /sogoumobilebrowser/i.test(userAgent)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_supporter, 'isMSOHU', /MSOHU/i.test(userAgent)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_supporter, 'isSupportLocalStorage', function () {
        var key = 'isSupportLocalStorage';
        var localStorage;

        try {
            // 当客户端禁用localStorage，访问时会报“Uncaught SecurityError”权限异常
            localStorage = window.localStorage;
        } catch (e) {
            localStorage = null;
            console.log(e);
            return false;
        }
        if (!!localStorage) {
            // ios Safari无痕模式下调用localStorage.setItem/removeItem会报错"QuotaExceededError"，需主动捕获
            try {
                localStorage.setItem(key, key);
                localStorage.removeItem(key);
                return true;
            } catch (e) {
                return false;
            }
        }
        return false;
    }()), _supporter);

    /* 自带浏览器 */
    supporter.isInstalled = supporter.isSafari || !supporter.isUC && !supporter.isQQ && !supporter.isWeixin && !supporter.isSogouBrowser && !supporter.isBaiduboxapp && !supporter.isBaiduBrowser;

    return supporter;
})(window));

/***/ }),

/***/ "GtYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__("XQ5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_supporter_js__ = __webpack_require__("CbiI");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            fixed_top: false,
            fix_home: true,
            isInApp: __WEBPACK_IMPORTED_MODULE_1__utils_supporter_js__["a" /* default */].isMSOHU
        };
    },

    methods: {
        back2top: function back2top() {
            window.scrollTo(0, 0);
        },
        back2home: function back2home() {
            window.location.href = '//m.sohu.com';
        }
    },
    mounted: function mounted() {
        var that = this;
        var heightTop = void 0;
        var showDistance = window.screen.availHeight * 2;
        window.addEventListener('scroll', __WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* default */].throttle(function (e) {
            heightTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (heightTop >= showDistance) {
                that.fixed_top = true;
            } else {
                that.fixed_top = false;
            }
        }, 200));
    }
});

/***/ }),

/***/ "bOdI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "dACX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-menu-wrap"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fixed_top),expression:"fixed_top"}],staticClass:"fixed_back_top fixed",on:{"click":_vm.back2top}},[_c('i',{staticClass:"icon icon-backtop"})]),_vm._v(" "),(!_vm.isInApp)?_c('div',{staticClass:"fixed_back_home fixed",on:{"click":_vm.back2home}},[_c('i',{staticClass:"icon icon-home"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "oLEQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.float-menu-wrap {\n  position: fixed;\n  right: 0.4rem;\n  bottom: 1.6rem;\n  z-index: 888;\n}\n.float-menu-wrap .fixed {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 0.933333rem;\n  height: 0.933333rem;\n  margin-top: 0.186667rem;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #fff;\n}\n.float-menu-wrap .fixed_back_top {\n  background: rgba(255, 244, 220, 0.95);\n  border: 1px solid rgba(252, 228, 175, 0.5);\n  background-size: contain;\n}\n.float-menu-wrap .fixed_back_top .icon {\n  font-size: 12px;\n  color: #fcca5b;\n}\n.float-menu-wrap .fixed_back_home {\n  background: rgba(255, 244, 220, 0.95);\n  border: 1px solid rgba(252, 228, 175, 0.5);\n  background-size: contain;\n}\n.float-menu-wrap .fixed_back_home .icon {\n  font-size: 20px;\n  color: #fcca5b;\n  margin-top: -0.026667rem;\n  margin-left: 0.026667rem;\n}", ""]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/6.ca495cf7fe8b15f5a2f0.js